import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoImage from '../assets/WhatsApp Image 2025-11-20 at 2.54.26 PM.jpeg';
import './Header.css';

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const navigate = useNavigate();

  return (
    <header className="header">
      <button className="menu-button" onClick={onMenuClick} aria-label="Menu">
        <span className="hamburger"></span>
        <span className="hamburger"></span>
        <span className="hamburger"></span>
      </button>
      <div className="logo-container" onClick={() => navigate('/')}>
        <img src={logoImage} alt="GamesHub Logo" className="logo-image" />
      </div>
      <button className="search-button" aria-label="Search">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
      </button>
    </header>
  );
};

export default Header;

